import { useEffect, useState } from 'react';
import clsx from 'clsx';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import { CircularProgress, DialogActions, DialogTitle } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { saveBaseline } from 'features/tasks/store/tasksSlice';

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: 'bold',
  },
  marginAuto: {
    margin: 'auto',
  },
  saveBtn: {
    padding: 5,
  },
  content: {
    minWidth: 400,
  },
}));

const formInitialState = {
  name: null,
};

/**
 *
 * @param {string} props.id
 * @param {string} props.open
 * @param {string} props.handleClose
 * @returns
 */
const BaselineDialog = ({ id, projectId, open, handleClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ name: false });
  const [formState, setFormState] = useState(formInitialState);
  const baselineList = useSelector((state) => state.tasks.baselines?.list);

  const handleOnChange = (event) => {
    setFormState({ name: event.target.value });
    if (event.target.value) {
      setError({ ...error, name: false });
    }
  };

  const handleSubmit = () => {
    if (!formState.name) {
      setError({ ...error, name: true });
      return false;
    }
    handleSave();
  };

  const handleKeyPress = (event) => {
    if (event.key !== 'Enter') return;
    if (!formState.name) {
      setError({ ...error, name: true });
      return false;
    }
    handleSave();
  };

  const handleSave = () => {
    setLoading(true);
    dispatch(
      saveBaseline({
        id,
        projectId: projectId,
        name: formState.name,
      })
    )
      .then(() => {
        setLoading(false);
        handleClose();
      })
      .catch(() => {
        setLoading(false);
        handleClose();
      });
  };

  useEffect(() => {
    if (baselineList && baselineList[id]) {
      setFormState(baselineList[id]);
    } else {
      setFormState(formInitialState);
    }
  }, [baselineList]);

  return (
    <Dialog id={id} open={open} onClose={handleClose}>
      <DialogTitle>{id ? 'Update' : 'Create'} Baseline</DialogTitle>
      {loading && <CircularProgress className="loading" />}
      <DialogContent className={classes.content} style={loading ? { opacity: 0.3 } : {}}>
        <Grid container direction="column" spacing={2}>
          <Grid container item spacing={2}>
            <Grid item className={classes.marginAuto} xs={2}>
              <Typography className={classes.label} variant="subtitle2">
                Name:
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <TextField
                autoFocus
                fullWidth
                error={error?.name ? true : false}
                size="small"
                value={formState.name}
                variant="outlined"
                onChange={handleOnChange}
                onKeyPress={handleKeyPress}
              />
            </Grid>
          </Grid>
          <Grid item className="flex">
            <Button
              className={clsx('green-button', classes.saveBtn)}
              size="small"
              onClick={handleSubmit}
            >
              {id ? 'Update' : 'Save'}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default BaselineDialog;
